import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/kedve/Reveal";
import { JOURNEY_STAGES } from "../data/kedve";

export default function CareerJourney() {
  return (
    <div data-testid="page-career-journey" className="text-black">
      <section className="pt-36 pb-20">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="eyebrow opacity-60">The Career Journey</div>
          <h1 className="mt-8 font-serif text-6xl md:text-8xl lg:text-[9.5rem] leading-[0.9] tracking-tightest">
            Seven stages.<br /><span className="italic">One trajectory.</span>
          </h1>
          <p className="mt-10 max-w-2xl text-lg opacity-70 leading-relaxed">
            Careers move in stages, not in years. Each stage asks something different of you. kedve is built around all seven.
          </p>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <ol className="relative border-l border-black/15 ml-2">
            {JOURNEY_STAGES.map((s, i) => (
              <Reveal key={s.code} delay={i * 80}>
                <li className="relative pl-10 md:pl-16 py-10 md:py-16 border-b border-black/10" data-testid={`journey-page-${s.code}`}>
                  <span className="absolute -left-[7px] top-14 w-3 h-3 rounded-full bg-black" />
                  <div className="grid md:grid-cols-12 gap-8 items-baseline">
                    <div className="md:col-span-2 font-mono text-xs opacity-60">Stage {s.code}</div>
                    <h2 className="md:col-span-4 font-serif text-5xl md:text-7xl tracking-tightest leading-[0.95]">{s.title}</h2>
                    <p className="md:col-span-6 text-lg md:text-xl leading-relaxed opacity-80">
                      {s.body}
                    </p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="bg-black text-white py-24 md:py-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 text-center">
          <h2 className="font-serif text-5xl md:text-7xl tracking-tightest leading-[0.9]">Where are you<br /><span className="italic">on the trajectory?</span></h2>
          <Link to="/accelerators" data-testid="journey-cta" className="mt-12 inline-flex items-center gap-2 bg-white text-black rounded-full px-8 py-4 text-sm tracking-wide hover:bg-white/90 transition">
            See the programs <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
